export default __webpack_public_path__ + "static/media/calendar.39e2c3d1.svg";